"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickedShowMore = void 0;

var _Schema = require("../../Schema");

/**
 * A user clicks a show more button on web.
 *
 *  @example
 *  ```
 *  clickedShowMore({
 *    context_module: "exhibitorsTab",
 *    context_page_owner_type: "fair",
 *    context_page_owner_id: "5e726bd22524980012caafb0",
 *    context_page_owner_slug: "arteba-special-edition",
 *    subject: "Show More"
 *  })
 * ```
 */
const clickedShowMore = props => {
  return {
    action: _Schema.ActionType.clickedShowMore,
    ...props
  };
};

exports.clickedShowMore = clickedShowMore;